import {
    LOGIN_ERROR,
    LOGIN_ERROR_CLEAR,
    LOGIN_PENDING,
    LOGIN_SUCCESS,
    LOGIN_USER_PROFILE,
    PROFILE_ERROR,
    PROFILE_ERROR_CLEAR,
    PROFILE_PENDING,
} from "./constants"

const initialState = {
    //------------------------------|| LOGIN ||---------------------------------------
    isAuth: false,
    isLoginPending: false,
    loginErrorMessage: null,
    //------------------------------|| PROFILE ||-------------------------------------
    userProfile: null,
    isProfilePending: false,
    profileErrorMessage: null,
}

const login = (state = initialState, action) => {

    switch (action.type) {
        //------------------------------|| LOGIN ||---------------------------------------
        case LOGIN_PENDING: {
            return {
                ...state,
                isLoginPending: true
            }
        }

        case LOGIN_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...state,
                loginErrorMessage: errorMessage,
                isLoginPending: false,
            }
        }

        case LOGIN_ERROR_CLEAR: {
            return {
                ...state,
                loginErrorMessage: null,
                isLoginPending: false,
            }
        }

        case LOGIN_SUCCESS: {
            return {
                ...state,
                isAuth: true,
                loginErrorMessage: null,
                isLoginPending: false,
            }
        }

        //------------------------------|| PROFILE ||-------------------------------------
        case PROFILE_PENDING: {
            return {
                ...state,
                isProfilePending: true
            }
        }

        case LOGIN_USER_PROFILE: {
            const { profile } = action.payload || {};
            return {
                ...state,
                userProfile: profile,
            }
        }

        case PROFILE_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...state,
                profileErrorMessage: errorMessage,
                isProfilePending: false,
            }
        }

        case PROFILE_ERROR_CLEAR: {
            return {
                ...state,
                profileErrorMessage: null,
                isProfilePending: false,
            }
        }

        default: {
            return state;
        }
    }
}

export default login;